<template>
<div class="container-lg">
  <v-alert v-model="alert" dismissible :color="alert_color" border="left" elevation="2" colored-border icon="mdi-check">
    {{alert_message}}
  </v-alert>
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex flex-column align-items-start">
      <h2>{{this.model['setting-name']}}</h2>
      <span class="text-muted">{{model['setting-description'] || 'Update field values'}}</span>
    </div>
  </div>
  <div class="card pl-4 pt-5 pb-5 pr-4 mt-5">
    <form action="" @submit.prevent="submitForm">
      <vue-form-generator ref="authorSettingsForm" tag="div" :schema="schema" :options="formOptions" :model="model" />
      <div class="d-flex justify-content-end mt-3 pr-4">
        <button type="submit" class="btn btn-primary btn-lg">
          {{ isSaving ? 'Saving...' : 'Submit'}}
        </button>
      </div>
    </form>
  </div>
</div>
</template>
<script>
import {
  mapState
} from 'vuex';
import userFormSchema from '../../forms/userFromSchema.js';
import ShuttleMixins from '@/mixins/ShuttleMixins.js';

export default {
  name: 'ShuttleSettingsEdit',
  mixins: [ShuttleMixins],
  data() {
    return {
      alert: false,
      alert_message: '',
      alert_color: 'green',
      alert_timeout_duration: 4200,
      model: {},
      schema: {},
      formOptions: {},
      isSaving: false,
      fieldSchema: userFormSchema,

      settingId: 0,
    }
  },
  async mounted() {
    this.settingId = this.$route.params.id;
    let path = this.$store.state.endpoint.post_customer + '/' + this.$store.state.auth.sub + '/settings', groups = [], data;
    try {
      data = await this.getData(path+'?type=1&setting_id=' + this.settingId, 'get');
      // check if empty first
      data = data.body.data.Items[0];
    } catch (err) {
      console.log("ERR", err);
    }
    if (data.enabled) {
      data.enabled.forEach((fieldset) => {
        let fields = [];
        for (let i = 0; i < fieldset.fields.length;i++){
          fields.push(this.fieldSchema[fieldset.fields[i]]);
        }
        groups.push({
          "legend": fieldset.legend ? fieldset.legend : "",
          "fields": fields
        });
      });
    }
    this.schema = {
      "groups": groups
    };
    if (data.model) {
      this.model = data.model;
    }
  },
  methods: {
    formError(e) {
      this.alert_color = "red";
      this.alert_message = "Something went wrong, failed to update user properties.";
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
      }, this.alert_timeout_duration);
    },
    formSuccess() {
      this.alert_color = "green";
      this.alert_message = "Updated user properties!";
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
      }, this.alert_timeout_duration);
    },
    async submitForm() {
      let validate = this.$refs.authorSettingsForm.vfg.validate();
      console.log("VALIDATE", validate);
      if (!validate) {
        this.formError("Invalid fields");
        return;
      }
      this.isSaving = true;
      let path = this.$store.state.endpoint.post_customer + '/' + this.$store.state.auth.sub + '/settings',
          updateResponse;
      try {
        updateResponse = await this.getData(path, 'post', {
          customer_id: this.$store.state.auth.sub,
          setting_id: this.settingId,
          model: this.model,
          type: 'update'
        });
        this.formSuccess();
      } catch (e) {
        this.formError(e);
      }
      this.isSaving = false;
    }
  },
}
</script>
